import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import StatCard from '../Components/StatCard';
import stats from '../data/LandingSectionData/stats';


const AISection = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const [ref1, inView1] = useInView({ triggerOnce: true });
  const [ref2, inView2] = useInView({ triggerOnce: true });
  const [ref3, inView3] = useInView({ triggerOnce: true });
  const [ref4, inView4] = useInView({ triggerOnce: true });

  const refs = [ref1, ref2, ref3, ref4];
  const inViews = [inView1, inView2, inView3, inView4];

  return (
    // <div className="flex flex-col">
     <section className="bg-bgDefault text-white px-4 py-12 sm:px-6 sm:py-14 md:px-8 md:py-16 lg:px-12 lg:py-20">
  <div className="container mx-auto xl:max-w-screen-xl overflow-hidden">
    <div
      className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-12 items-center gap-6 sm:gap-8 md:gap-10 lg:gap-10"
      data-aos="fade-up"
      data-aos-easing="linear"
      data-aos-duration="1000"
    >
      {/* Left: Image */}
      <div className="order-2 md:order-1 lg:col-span-6 flex justify-center sm:justify-center md:justify-start px-0 sm:px-4 md:px-0 lg:px-16 sm:mt-8 md:mt-0">
        <img
          src="/company_img/team-photo.png"
          alt="Techxplore team delivering AI-driven technology solutions, backed by over 5 years of industry expertise, 50+ satisfied clients, and a proven track record of innovation, reliability, and human impact."
          className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg"
        />
      </div>

      {/* Right: Text + Stats */}
      <div className="order-1 md:order-2 lg:col-span-6 px-0 sm:px-4 md:px-0">
        <h3 className="font-bold leading-tight mb-6">
          <span className="text-[#00E599] text-[28px] sm:text-[36px] md:text-[48px] lg:text-heading-2 sm:leading-[44px] md:leading-[56px] lg:leading-[72px] font-normal italic font-crimsonpro lg:tracking-[-0.06em]">
            Reimagining
          </span>{"  "}
          
          <span className="text-white text-[24px] sm:text-[32px] md:text-[40px] lg:text-heading-2 font-dmsans ">
            
              &nbsp;Enterprise
            
          </span>
          <br />
          <span className="text-white text-[24px] sm:text-[32px] md:text-[40px] lg:text-heading-2  font-dmsans">
            
            Transformation with AI
            

          </span>
        </h3>

        <p className="text-[#9E9E9E] text-body-sm sm:text-[15px] md:text-[16px] lg:text-body mb-10 font-roboto">
          Helping Enterprises harness AI, Cloud, and Advanced Engineering to accelerate innovation, scale seamlessly and highly scalable digital solutions for the future.
        </p>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8 md:lg:pr-20">
          {stats.map((item, idx) => (
            <StatCard
              key={idx}
              value={item.value}
              suffix={item.suffix}
              label={item.label}
              inView={inViews[idx]}
              cardRef={refs[idx]}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
</section>
   
  );
};

export default AISection;
